export default __webpack_public_path__ + "static/media/rocket_anim_73.1288aa21.png";